import { Loader2, AlertTriangle, Inbox } from "lucide-react";
import { Button } from "@/components/ui/button";
import { apiError } from "@/lib/api";

export function Loading({ label = "Carregando…" }) {
  return (
    <div className="py-16 flex flex-col items-center justify-center text-slate-400 gap-3">
      <Loader2 className="h-6 w-6 animate-spin text-orange-500" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function ErrorState({ error, onRetry }) {
  return (
    <div className="py-14 flex flex-col items-center justify-center gap-3 text-center">
      <AlertTriangle className="h-7 w-7 text-rose-500" />
      <p className="text-sm text-slate-400 max-w-md">{apiError(error)}</p>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry} data-testid="retry-btn">
          Tentar novamente
        </Button>
      )}
    </div>
  );
}

export function Empty({ label = "Nenhum registro encontrado" }) {
  return (
    <div className="py-14 flex flex-col items-center justify-center gap-3 text-slate-500">
      <Inbox className="h-7 w-7" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
